import React, { useEffect, useState } from 'react';
import {
  Button, Div, Panel,
  SimpleCell, Text, Title, PullToRefresh,
} from '@vkontakte/vkui';
import { useAppContext } from '../../AppContext';
import { Panels } from '../Consts';
import { UserAvatar } from '../components/UserAvatar';
import { ErrorLoadComponent } from '../components/ErrorLoadComponent';
import { clearCache as eventInfoCacheClear } from '../Events/ShowEventPanel';
import { ImgsGallery } from '../components/ImgsGalleryComponent';
import { getRouteEditRepayment, getRouteEventInfo } from '../../route';
import { PlatformPanelHeader } from '../components/PlatformPanelHeader';

const CURRENT_PANEL = Panels.REPAYMENT_INFO_PANEL;

const ShowRepaymentPanel = () => {
  const context = useAppContext();
  const params = context.router.getParams();

  const [item, setItem] = useState(null);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [errorInit, setErrorInit] = useState(null);
  const [isRefreshFetching, setIsRefreshFetching] = React.useState(false);

  const fetch = () => {
    context.spinner(true);
    context.init().then(() => {
      context.httpClient().getRepayment(params.eventId, params.id)
        .then((response) => {
          const users = {};
          response.data.users.forEach((user) => {
            users[user.id] = user;
          });

          response.data.users.forEach((user) => {
            if (user.id === response.data.item.from) {
              setFrom(user);
            }
            if (user.id === response.data.item.to) {
              setTo(user);
            }
          });

          setItem(response.data.item);
          setErrorInit(null);
          context.spinner(false);
        }).catch((error) => {
          setErrorInit(error);
        });
    }).catch((error) => {
      setErrorInit(error);
    });
  }

  const onRefresh = () => {
    setIsRefreshFetching(true);

    context.httpClient()
      .getRepayment(params.eventId, params.id)
      .then((response) => {
        const users = {};
        response.data.users.forEach((user) => {
          users[user.id] = user;
        });

        response.data.users.forEach((user) => {
          if (user.id === response.data.item.from) {
            setFrom(user);
          }
          if (user.id === response.data.item.to) {
            setTo(user);
          }
        });

        setItem(response.data.item);
        setErrorInit(null);
        setIsRefreshFetching(false);
      })
      .catch((error) => {
        setErrorInit(error);
        setIsRefreshFetching(false);
      });
  }

  useEffect(() => {
    fetch();
  }, []);

  const toEdit = () => {
    context.router.push(...getRouteEditRepayment(params.id, params.eventId));
  }

  const deleteHandle = () => {
    context.confirm(
      context.lang().getKey(CURRENT_PANEL, 'confirm_delete_text'),
      (value) => {
        if (!value) {
          return;
        }

        context.httpClient()
          .deleteRepaymentV1(params.eventId, params.id)
          .then(() => {
            eventInfoCacheClear(params.eventId, context.cache);
            context.router.backTo(Panels.EVENT_INFO)
              .then(() => {})
              .catch((r) => r.replace(...getRouteEventInfo(params.eventId)));
          })
          .catch((error) => context.showError(error));
      },
      context.lang().getKey(CURRENT_PANEL, 'confirm_delete_yes_button'),
      context.lang().getKey(CURRENT_PANEL, 'confirm_delete_no_button')
    );
  }

  if (errorInit) {
    return (<ErrorLoadComponent
      error={errorInit}
      onFetch={fetch}
    />)
  }

  if (item === null) {
    return(<Panel id={CURRENT_PANEL}></Panel>);
  }

  return (<Panel id={CURRENT_PANEL}>
    <PlatformPanelHeader
      text={context.lang().getKey(CURRENT_PANEL, 'header')}
    />
    {context.snackbar}
    <PullToRefresh onRefresh={() => onRefresh()} isFetching={isRefreshFetching}>
      <Div>
        <Title level="2" weight="1">{item.name}</Title>
        {item.comment.length > 0 && (<Text weight="2">{item.comment}</Text>)}
        <Text weight="2" >{context.lang().dateFormatLong(new Date(item.date))}</Text>
      </Div>
      <SimpleCell
        disabled={true}
        subtitle={context.lang().getKey(CURRENT_PANEL, 'from_label')}
        before={<UserAvatar type={from.type} src={from.img} name={from.name} id={from.id} />}
        after={'-' + item.amount}
      >
        {from.name}
      </SimpleCell>
      <SimpleCell
        disabled={true}
        subtitle={context.lang().getKey(CURRENT_PANEL, 'to_label')}
        key={to.id}
        before={<UserAvatar type={to.type} src={to.img} name={to.name} id={to.id} />}
        after={'+' + item.amount}
      >
        {to.name}
      </SimpleCell>
      <Div>
        <ImgsGallery images={item.images} />
      </Div>
    </PullToRefresh>
    <Div>
      <Button
        stretched
        size="l"
        mode="outline"
        appearance="negative"
        onClick={deleteHandle}
      >
        {context.lang().getKey('app', 'delete_button_label')}
      </Button>
    </Div>
    <Div>
      <Button
        stretched
        size="l"
        onClick={toEdit}
      >
        {context.lang().getKey('app', 'edit_button_label')}
      </Button>
    </Div>
  </Panel>);
}

export default ShowRepaymentPanel;
